export default [
  { key: "no", label: "ลำดับที่", sortable: true , thStyle:{color:"white",width: "5% !important"}},
  {
    key: "roleName",
    label: "ชื่อกลุ่มสิทธิ์",
    thStyle:{color:"white"}
  },  
  {
    key: "roleDescription",
    label: "รายละเอียด",
    thStyle:{color:"white"}
  }, 
 
  { key: "roleStatus", label: "สถานะ", sortable: true , thStyle:{color:"white",width: "8% !important"}},  
  {
    key: "action",
    label: "จัดการ",
    sortable: false,
    thStyle: { width: "12% !important", textAlign: "center", color:"white" },
  },
];
